import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range.js";
import { t } from "@/localization";

// Date logic for onboarding's "when" step (EventWhenStep.js), kept free of
// React Native components so it can be unit-tested.

export const QUESTION = {
  wedding: t("When is the wedding?"),
  funeral: t("When is the service?"),
  birthday: t("When is the party?"),
  school: t("When is the ceremony?"),
  sport: t("When is the game?"),
  other: t("When is your event?"),
};

// The picked wall-clock date and time, in the event's time zone.
export const pickedMoment = ({
  event_date_local,
  event_time_local,
  event_timezone,
}) =>
  event_date_local && event_time_local
    ? moment.tz(
        `${event_date_local} ${event_time_local}`,
        "YYYY-MM-DD HH:mm",
        event_timezone || moment.tz.guess()
      )
    : null;

// Onboarding has always stored the event time as a device-local instant
// (SignUpSignIn re-reads its wall clock in event_timezone), so keep doing that.
const deviceInstant = (date, time) =>
  moment(`${date} ${time}`, "YYYY-MM-DD HH:mm").toISOString();

export const setWhen = (f, changes) => {
  const date = changes.date ?? f.values.event_date_local;
  const time = changes.time ?? f.values.event_time_local;
  f.setValues(
    {
      ...f.values,
      event_date_local: date || "",
      event_time_local: time || "",
      ...(changes.quick ? { date_quick: changes.quick } : {}),
      event_datetime_utc: date && time ? deviceInstant(date, time) : null,
      date_source: date && time ? "picked" : "",
    },
    false
  );
};

// What's missing or wrong, per field; shown next to that field's label once
// the host has pressed Continue. A start up to an hour ago is fine (hosts at
// the venue pick Today and the current time).
export const whenErrors = (values, now = moment()) => {
  const { event_date_local: date, event_time_local: time } = values;
  const errors = {};
  if (!date) errors.date = t("Pick a date");
  if (!time) errors.time = t("Pick a start time");
  if (
    date &&
    time &&
    pickedMoment(values).isBefore(now.clone().subtract(1, "hour"))
  ) {
    errors.time = t("That time has already passed");
  }
  return errors;
};

export const whenProblem = (values, now = moment()) => {
  const errors = whenErrors(values, now);
  return errors.date || errors.time || null;
};

// Stored onboarding answers from an earlier visit only keep a date the host
// picked themselves, and only while it is still ahead.
export const withoutStaleDate = (stored) => {
  if (!stored || typeof stored !== "object") return stored;
  const keep =
    stored.date_source === "picked" &&
    !whenProblem(stored) &&
    !!stored.event_datetime_utc;
  if (keep) return stored;
  const {
    event_datetime_utc,
    event_date_local,
    event_time_local,
    date_source,
    date_quick,
    ...rest
  } = stored;
  return rest;
};
